// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header start
// ----------------------
//
// PROPRIETARY / CONFIDENTIAL.
// Use of this product is subject to license terms.
// Copyright (c) 2022 NortonLifeLock
// All rights reserved.
//
// -------------------------------------------------------------------------------------------------
// NortonLifeLock copyright header stop
// ----------------------
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.9375rem;
  width: 100%;

  img {
    align-self: center;
  }
`;

interface IOnboardStep {
  image: string;
  children: React.ReactNode;
}

export const OnboardStep: FunctionComponent<IOnboardStep> = ({ image, children }) => {
  return (
    <Container>
      <>{children}</>
      {image && <img src={image} alt={`${image.split('-')[0]}-image`} />}
    </Container>
  );
};
